import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MotInputComponent } from './components/mot-input/mot-input.component';
import { MotButtonComponent } from './components/mot-button/mot-button.component';
import { MotAutocompleteComponent } from './components/mot-autocomplete/mot-autocomplete.component';
import { MotButtonToggleComponent } from './components/mot-button-toggle/mot-button-toggle.component';
import { MotTabsComponent } from './components/mot-tabs/mot-tabs.component';
import { MotSelectComponent } from './components/mot-select/mot-select.component';
import { MotTabComponent } from './components/mot-tab/mot-tab.component';
import { SharedModule } from '../@shared/shared.module';
import { MotDatePickerComponent } from './components/mot-date-picker/mot-date-picker.component';
import { MotTimePickerComponent } from './components/mot-time-picker/mot-time-picker.component';
import { MotDateTimePickingFormComponent } from './mot-date-time-picking-form/mot-date-time-picking-form.component';
import { MotCheckboxComponent } from './components/mot-checkbox/mot-checkbox.component';
import { MotMultiButtonToggleComponent } from './components/mot-multi-button-toggle/mot-multi-button-toggle.component';
import { MotRadioButtonComponent } from './components/mot-radio-button/mot-radio-button.component';
import { MotSliderComponent } from './components/mot-slider/mot-slider.component';
import { MotMultiCheckboxComponent } from './components/mot-multi-checkbox/mot-multi-checkbox.component';
import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { MaterialModule } from '../@shared/material.module';
import { MotMenuComponent } from './components/mot-menu/mot-menu.component';
import { MotSlideToggleComponent } from './components/mot-slide-toggle/mot-slide-toggle.component';
import { MotTableComponent } from './components/mot-table/mot-table.component';
import { MotLoadingButtonComponent } from './components/mot-button/mot-loading-button/mot-loading-button.component';

@NgModule({
  declarations: [
    MotInputComponent,
    MotButtonComponent,
    MotAutocompleteComponent,
    MotButtonToggleComponent,
    MotTabsComponent,
    MotSelectComponent,
    MotTabComponent,
    MotDatePickerComponent,
    MotTimePickerComponent,
    MotDateTimePickingFormComponent,
    MotCheckboxComponent,
    MotMultiButtonToggleComponent,
    MotRadioButtonComponent,
    MotSliderComponent,
    MotMultiCheckboxComponent,
    MotMenuComponent,
    MotSlideToggleComponent,
    MotTableComponent,
    MotLoadingButtonComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    OverlayModule,
    A11yModule,
    BidiModule,
  ],
  exports: [
    ReactiveFormsModule,
    MotInputComponent,
    MotButtonComponent,
    MotAutocompleteComponent,
    MotButtonToggleComponent,
    MotTabsComponent,
    MotSelectComponent,
    MotTabComponent,
    MotDatePickerComponent,
    MotTimePickerComponent,
    MotDateTimePickingFormComponent,
    MotCheckboxComponent,
    MotMultiButtonToggleComponent,
    MotRadioButtonComponent,
    MotSliderComponent,
    MotMultiCheckboxComponent,
    MotMenuComponent,
    MotSlideToggleComponent,
    MotTableComponent,
    MotLoadingButtonComponent,
    BidiModule,
  ],
})
export class FormsModule { }
